import { render, staticRenderFns } from "./MotivoFinalizacao.vue?vue&type=template&id=7180d67c"
import script from "./MotivoFinalizacao.vue?vue&type=script&lang=js"
export * from "./MotivoFinalizacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports